import { render, staticRenderFns } from "./DebuggingConsole.vue?vue&type=template&id=9b231b8e&scoped=true"
import script from "./DebuggingConsole.vue?vue&type=script&lang=js"
export * from "./DebuggingConsole.vue?vue&type=script&lang=js"
import style0 from "./DebuggingConsole.vue?vue&type=style&index=0&id=9b231b8e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b231b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b231b8e')) {
      api.createRecord('9b231b8e', component.options)
    } else {
      api.reload('9b231b8e', component.options)
    }
    module.hot.accept("./DebuggingConsole.vue?vue&type=template&id=9b231b8e&scoped=true", function () {
      api.rerender('9b231b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DebuggingConsole.vue"
export default component.exports